(function () {
  var ROOT_SELECTOR = '[data-townwine-deals]';
  var PRODUCTS_ENDPOINT = '/products.json?limit=250';
  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var DETAIL_FETCH_LIMIT = 48;
  var KRW_RATE = 180;

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .toLowerCase();
  }

  function toInteger(value, fallback) {
    var parsedValue = Number(String(value || '').trim());

    if (!Number.isFinite(parsedValue)) {
      return fallback;
    }

    return Math.trunc(parsedValue);
  }

  function formatMoney(value) {
    var amount = Number(value || 0);

    return 'HKD ' + amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  function formatKrwMoney(value) {
    var amount = Number(value || 0) * KRW_RATE;
    return 'KRW ₩' + Math.round(amount).toLocaleString('ko-KR');
  }

  function getStateFromUrl() {
    var params = new URLSearchParams(window.location.search);

    return {
      query: normalizeText(params.get('q') || ''),
      tag: String(params.get('tag') || '').trim(),
      price: String(params.get('price') || '').trim(),
      stock: String(params.get('stock') || '').trim(),
      sort: String(params.get('sort') || 'latest').trim() || 'latest',
    };
  }

  function updateUrl(state) {
    var params = new URLSearchParams();

    if (state.query) {
      params.set('q', state.query);
    }

    if (state.tag) {
      params.set('tag', state.tag);
    }

    if (state.price) {
      params.set('price', state.price);
    }

    if (state.stock) {
      params.set('stock', state.stock);
    }

    if (state.sort && state.sort !== 'latest') {
      params.set('sort', state.sort);
    }

    var nextUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', nextUrl);
  }

  function fetchJson(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('DEALS_PRODUCTS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function fetchText(url) {
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('DEALS_PRODUCT_HTML_REQUEST_FAILED');
      }

      return response.text();
    });
  }

  function getText(node) {
    return node && typeof node.textContent === 'string' ? node.textContent.trim() : '';
  }

  function getFirstAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];

    return (
      variants.find(function (variant) {
        return Boolean(variant && variant.available);
      }) ||
      variants[0] ||
      null
    );
  }

  function hasAvailableVariant(product) {
    var variants = Array.isArray(product && product.variants) ? product.variants : [];

    return variants.some(function (variant) {
      return Boolean(variant && variant.available);
    });
  }

  function getPrimaryPrice(product) {
    var variant = getFirstAvailableVariant(product);

    if (variant && variant.price != null) {
      return Number(variant.price || 0);
    }

    return 0;
  }

  function getPriceBand(product) {
    var priceValue = getPrimaryPrice(product);

    if (priceValue >= 300 && priceValue < 400) {
      return '30s';
    }

    if (priceValue >= 400 && priceValue < 700) {
      return '40to69';
    }

    if (priceValue >= 700) {
      return '70plus';
    }

    return '';
  }

  function getKnownTags(product) {
    var productTags = Array.isArray(product && product.tags) ? product.tags : [];

    return productTags.filter(function (tag) {
      return ['레드', '화이트', '스파클링', '내추럴', '바로배송'].indexOf(tag) !== -1;
    });
  }

  function parseCollectorNameFromTitle(title) {
    var value = String(title || '').trim();
    var match = value.match(/^\d{4}\.\d{2}\.\d{2}\s+(.+?)\s+pick\b/i);

    return match ? match[1].trim() : '';
  }

  function parseCollectorData(html, product) {
    var doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
    var followButton = doc.querySelector('.js-follow-btn[data-influencer-handle]');
    var nameNode = doc.querySelector('.imini__nm a, .imini__nm');
    var linkNode = doc.querySelector('.imini__nm a');
    var metaSpans = toArray(doc.querySelectorAll('.imini__h span'));
    var handleLabel = '';

    metaSpans.some(function (node) {
      var value = getText(node);

      if (value.indexOf('@') === 0) {
        handleLabel = value;
        return true;
      }

      return false;
    });

    var followHandle = normalizeHandle(
      followButton instanceof HTMLElement ? followButton.dataset.influencerHandle || '' : '',
    );
    var displayName = getText(nameNode);
    var collectorUrl =
      linkNode instanceof HTMLAnchorElement ? linkNode.getAttribute('href') || '' : '';
    var fallbackName = parseCollectorNameFromTitle(product && product.title);

    return {
      followHandle: followHandle,
      followName:
        (followButton instanceof HTMLElement && followButton.dataset.influencerName) ||
        displayName ||
        fallbackName,
      displayName: displayName || fallbackName,
      handleLabel: handleLabel,
      collectorUrl: collectorUrl,
    };
  }

  async function fetchCollectorDetails(products) {
    var details = new Map();
    var targets = products.slice(0, DETAIL_FETCH_LIMIT);

    await Promise.all(
      targets.map(async function (product) {
        try {
          var html = await fetchText('/products/' + product.handle + '?view=default');
          details.set(product.handle, parseCollectorData(html, product));
        } catch (error) {
          details.set(product.handle, {
            followHandle: '',
            followName: parseCollectorNameFromTitle(product.title),
            displayName: parseCollectorNameFromTitle(product.title),
            handleLabel: '',
            collectorUrl: '',
          });
        }
      }),
    );

    return details;
  }

  function createImageMarkup(product) {
    var image = Array.isArray(product && product.images) && product.images.length ? product.images[0] : null;

    if (!image || !image.src) {
      return '<div class="tw-card-fallback" aria-hidden="true"></div>';
    }

    return (
      '<img src="' +
      escapeHtml(image.src) +
      '" class="tw-card-image" alt="' +
      escapeHtml(product.title) +
      '" loading="lazy">'
    );
  }

  function buildFollowButton(collector, proxyBase) {
    if (!collector.followHandle) {
      return '';
    }

    return (
      '<button class="follow js-follow-btn" type="button" ' +
      'onclick="if (event) { event.__townwineFollowHandled = true; } if (window.TownWineFollow && typeof window.TownWineFollow.handleButtonClick === \'function\') { window.TownWineFollow.handleButtonClick(this, event); }" ' +
      'data-influencer-handle="' +
      escapeHtml(collector.followHandle) +
      '" ' +
      'data-influencer-name="' +
      escapeHtml(collector.followName || collector.displayName || '') +
      '" ' +
      'data-proxy-base="' +
      escapeHtml(proxyBase) +
      '" ' +
      'data-follow-label="팔로우" ' +
      'data-following-label="팔로잉" ' +
      'data-return-to="' +
      escapeHtml(window.location.pathname + window.location.search + window.location.hash) +
      '" ' +
      'aria-pressed="false">팔로우</button>'
    );
  }

  function buildCardMarkup(product, collector, proxyBase, index) {
    var variant = getFirstAvailableVariant(product);

    if (!variant) {
      return '';
    }

    var available = hasAvailableVariant(product);
    var createdTimestamp = new Date(product.created_at || 0).getTime() || 0;
    var priceValue = Number(variant.price || 0);
    var comparePrice = Number(variant.compare_at_price || 0);
    var discountPercent =
      comparePrice > priceValue ? Math.round(((comparePrice - priceValue) * 100) / comparePrice) : 0;
    var tagKeys = getKnownTags(product);
    var priceBand = getPriceBand(product);
    var hasCollector = Boolean(collector && (collector.followHandle || collector.displayName));
    var collectorName = hasCollector ? collector.displayName || collector.followName : '컬렉터 미지정';
    var collectorMeta = hasCollector
      ? [product.vendor, collector.handleLabel].filter(Boolean).join(' · ')
      : product.vendor || '';
    var collectorLink = hasCollector && collector.collectorUrl ? collector.collectorUrl : '';
    var initial = (collectorName || product.vendor || '컬').slice(0, 1);
    var subtitle = [product.product_type || 'Curated wine', product.vendor || '']
      .filter(Boolean)
      .join(' · ');
    var searchIndex = normalizeText(
      [
        product.title,
        product.vendor,
        collectorName,
        collectorMeta,
        subtitle,
        tagKeys.join(' '),
      ].join(' '),
    );
    var infoOpen = collectorLink ? '<a class="dc__ii" href="' + escapeHtml(collectorLink) + '">' : '<div class="dc__ii">';
    var infoClose = collectorLink ? '</a>' : '</div>';
    var badgeHtml = available ? '' : '<div class="dc__b"><span class="bd bd--soft">공구 종료</span></div>';
    var compareHtml =
      comparePrice > priceValue
        ? '<span class="strk">' + escapeHtml(formatMoney(comparePrice)) + '</span>'
        : '';
    var discountHtml =
      discountPercent > 0 ? '<span class="pct">-' + escapeHtml(discountPercent) + '%</span>' : '';

    return (
      '<div class="tdl-card-item" ' +
      'data-deal-card ' +
      'data-search-index="' +
      escapeHtml(searchIndex) +
      '" ' +
      'data-tags="' +
      escapeHtml(tagKeys.join('|')) +
      '" ' +
      'data-price-band="' +
      escapeHtml(priceBand) +
      '" ' +
      'data-stock-state="' +
      (available ? 'available' : 'soldout') +
      '" ' +
      'data-sort-popularity="' +
      escapeHtml(index) +
      '" ' +
      'data-sort-closing="' +
      (available ? '0' : '1000000') +
      '" ' +
      'data-sort-latest="' +
      escapeHtml(Math.trunc(createdTimestamp / 1000)) +
      '">' +
      '<article class="dc" data-townwine-product-card-url="/products/' +
      escapeHtml(product.handle) +
      '">' +
      '<a class="dc__m dc__m-link" href="/products/' +
      escapeHtml(product.handle) +
      '" aria-label="' +
      escapeHtml(product.title) +
      '">' +
      badgeHtml +
      createImageMarkup(product) +
      '</a>' +
      '<div class="dc__bd">' +
      '<div class="dc__inf">' +
      infoOpen +
      '<span class="mini">' +
      escapeHtml(initial) +
      '</span>' +
      '<div class="dc__nm">' +
      escapeHtml(collectorName) +
      '<span>' +
      escapeHtml(collectorMeta) +
      '</span></div>' +
      infoClose +
      buildFollowButton(collector || {}, proxyBase) +
      '</div>' +
      '<div><h3 class="dc__t"><a href="/products/' +
      escapeHtml(product.handle) +
      '">' +
      escapeHtml(product.title) +
      '</a><em>' +
      escapeHtml(subtitle) +
      '</em></h3></div>' +
      '<div class="pg" data-townwine-inventory-card data-variant-id="' +
      escapeHtml(variant.id) +
      '" data-proxy-base="' +
      escapeHtml(proxyBase) +
      '">' +
      '<div class="pg__bar"><div class="pg__fl" style="width:0%" data-inventory-progress-bar></div></div>' +
      '<div class="pg__mt"><span data-inventory-summary>' +
      (available ? '판매 수량 확인 중' : '공구 종료') +
      '</span><span data-inventory-caption>' +
      (available ? '재고 정보 확인 중' : '재고 없음') +
      '</span></div>' +
      '</div>' +
      '<div class="pr"><div class="pr__main">' +
      compareHtml +
      '<span class="now">' +
      escapeHtml(formatMoney(priceValue)) +
      '</span>' +
      discountHtml +
      '</div><div class="pr__sub">' +
      escapeHtml(formatKrwMoney(priceValue)) +
      '</div></div>' +
      '<a class="btn btn--dark btn--block dc__cta" href="/products/' +
      escapeHtml(product.handle) +
      '">' +
      (available ? '딜 자세히 보기' : '종료 딜 보기') +
      '</a>' +
      '</div></article></div>'
    );
  }

  function getCards(root) {
    return toArray(root.querySelectorAll('[data-deal-card]'));
  }

  function syncSearchInput(root, state) {
    var input = root.querySelector('[data-deals-search]');

    if (input instanceof HTMLInputElement) {
      input.value = state.query;
    }
  }

  function syncChipState(root, state) {
    toArray(root.querySelectorAll('[data-deals-tag]')).forEach(function (button) {
      var isActive = (button.dataset.dealsTag || '') === state.tag;
      button.classList.toggle('is-on', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    toArray(root.querySelectorAll('[data-deals-price]')).forEach(function (button) {
      var isActive = (button.dataset.dealsPrice || '') === state.price;
      button.classList.toggle('is-on', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    toArray(root.querySelectorAll('[data-deals-stock]')).forEach(function (button) {
      var isActive = (button.dataset.dealsStock || '') === state.stock;
      button.classList.toggle('is-on', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    toArray(root.querySelectorAll('[data-deals-sort]')).forEach(function (button) {
      var isActive =
        !state.stock && (button.dataset.dealsSort || 'latest') === state.sort;
      button.classList.toggle('is-on', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function setChipCount(root, selector, value) {
    var button = root.querySelector(selector);
    var counter = button ? button.querySelector('.chip__c') : null;

    if (counter instanceof HTMLElement) {
      counter.textContent = String(value);
    }
  }

  function updateCounts(root, products) {
    var total = products.length;
    var redCount = 0;
    var whiteCount = 0;
    var sparklingCount = 0;
    var naturalCount = 0;
    var readyCount = 0;
    var price30Count = 0;
    var price4069Count = 0;
    var price70Count = 0;
    var availableCount = 0;

    products.forEach(function (product) {
      var tags = getKnownTags(product);
      var priceBand = getPriceBand(product);
      var available = hasAvailableVariant(product);

      if (tags.indexOf('레드') !== -1) {
        redCount += 1;
      }
      if (tags.indexOf('화이트') !== -1) {
        whiteCount += 1;
      }
      if (tags.indexOf('스파클링') !== -1) {
        sparklingCount += 1;
      }
      if (tags.indexOf('내추럴') !== -1) {
        naturalCount += 1;
      }
      if (tags.indexOf('바로배송') !== -1) {
        readyCount += 1;
      }
      if (available) {
        availableCount += 1;
      }

      if (priceBand === '30s') {
        price30Count += 1;
      } else if (priceBand === '40to69') {
        price4069Count += 1;
      } else if (priceBand === '70plus') {
        price70Count += 1;
      }
    });

    setChipCount(root, '[data-deals-tag=""]', total);
    setChipCount(root, '[data-deals-tag="레드"]', redCount);
    setChipCount(root, '[data-deals-tag="화이트"]', whiteCount);
    setChipCount(root, '[data-deals-tag="스파클링"]', sparklingCount);
    setChipCount(root, '[data-deals-tag="내추럴"]', naturalCount);
    setChipCount(root, '[data-deals-tag="바로배송"]', readyCount);
    setChipCount(root, '[data-deals-price="30s"]', price30Count);
    setChipCount(root, '[data-deals-price="40to69"]', price4069Count);
    setChipCount(root, '[data-deals-price="70plus"]', price70Count);
    setChipCount(root, '[data-deals-stock="available"]', availableCount);
  }

  function sortCards(root, state) {
    var grid = root.querySelector('[data-deals-grid]');
    var cards = getCards(root);

    if (!(grid instanceof HTMLElement) || !cards.length) {
      return;
    }

    cards
      .sort(function (left, right) {
        if (state.sort === 'closing') {
          var closingDelta =
            toInteger(left.dataset.sortClosing, 999999999) -
            toInteger(right.dataset.sortClosing, 999999999);

          if (closingDelta !== 0) {
            return closingDelta;
          }
        } else if (state.sort === 'latest') {
          var latestDelta =
            toInteger(right.dataset.sortLatest, 0) -
            toInteger(left.dataset.sortLatest, 0);

          if (latestDelta !== 0) {
            return latestDelta;
          }
        }

        return (
          toInteger(left.dataset.sortPopularity, 999999) -
          toInteger(right.dataset.sortPopularity, 999999)
        );
      })
      .forEach(function (card) {
        grid.appendChild(card);
      });
  }

  function applyFilters(root, state) {
    var visibleCount = 0;
    var countNode = root.querySelector('[data-deals-visible-count]');
    var emptyNode = root.querySelector('[data-deals-empty]');

    getCards(root).forEach(function (card) {
      var searchIndex = normalizeText(card.dataset.searchIndex || '');
      var tags = String(card.dataset.tags || '')
        .split('|')
        .map(function (tag) {
          return tag.trim();
        })
        .filter(Boolean);
      var priceBand = String(card.dataset.priceBand || '').trim();
      var stockState = String(card.dataset.stockState || '').trim();

      var matchesQuery = !state.query || searchIndex.indexOf(state.query) !== -1;
      var matchesTag = !state.tag || tags.indexOf(state.tag) !== -1;
      var matchesPrice = !state.price || priceBand === state.price;
      var matchesStock = !state.stock || stockState === state.stock;
      var isVisible = matchesQuery && matchesTag && matchesPrice && matchesStock;

      card.hidden = !isVisible;

      if (isVisible) {
        visibleCount += 1;
      }
    });

    if (countNode instanceof HTMLElement) {
      countNode.textContent = String(visibleCount);
    }

    if (emptyNode instanceof HTMLElement) {
      emptyNode.hidden = visibleCount !== 0;
    }
  }

  function render(root, state) {
    syncSearchInput(root, state);
    syncChipState(root, state);
    sortCards(root, state);
    applyFilters(root, state);
    updateUrl(state);
  }

  async function hydrateGrid(root, state) {
    var grid = root.querySelector('[data-deals-grid]');
    var proxyBase = root.dataset.proxyBase || DEFAULT_PROXY_BASE;

    if (!(grid instanceof HTMLElement)) {
      return;
    }

    grid.style.visibility = 'hidden';
    grid.innerHTML = '';

    var payload = await fetchJson(PRODUCTS_ENDPOINT);
    var products = Array.isArray(payload && payload.products) ? payload.products : [];
    var sortedProducts = products.slice().sort(function (left, right) {
      return new Date(right.created_at || 0).getTime() - new Date(left.created_at || 0).getTime();
    });
    var collectorDetails = await fetchCollectorDetails(sortedProducts);

    grid.innerHTML = sortedProducts
      .map(function (product, index) {
        return buildCardMarkup(product, collectorDetails.get(product.handle) || {}, proxyBase, index);
      })
      .join('');

    updateCounts(root, sortedProducts);
    grid.style.visibility = '';

    if (window.TownWineFollow && typeof window.TownWineFollow.init === 'function') {
      window.TownWineFollow.init(root);
    }

    if (window.TownWineCollectorStats && typeof window.TownWineCollectorStats.init === 'function') {
      window.TownWineCollectorStats.init(root);
    }

    render(root, state);
  }

  function initialize(root) {
    if (!(root instanceof HTMLElement) || root.dataset.dealsReady === 'true') {
      return;
    }

    root.dataset.dealsReady = 'true';
    var state = getStateFromUrl();
    var searchInput = root.querySelector('[data-deals-search]');

    if (searchInput instanceof HTMLInputElement) {
      searchInput.addEventListener('input', function () {
        state.query = normalizeText(searchInput.value);
        render(root, state);
      });
    }

    var searchTrigger = root.querySelector('[data-deals-search-trigger]');

    if (searchTrigger instanceof HTMLButtonElement && searchInput instanceof HTMLInputElement) {
      searchTrigger.addEventListener('click', function () {
        state.query = normalizeText(searchInput.value);
        render(root, state);
        searchInput.focus();
      });
    }

    toArray(root.querySelectorAll('[data-deals-tag]')).forEach(function (button) {
      button.addEventListener('click', function () {
        state.tag = String(button.dataset.dealsTag || '').trim();
        render(root, state);
      });
    });

    toArray(root.querySelectorAll('[data-deals-price]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var nextValue = String(button.dataset.dealsPrice || '').trim();
        state.price = state.price === nextValue ? '' : nextValue;
        render(root, state);
      });
    });

    toArray(root.querySelectorAll('[data-deals-stock]')).forEach(function (button) {
      button.addEventListener('click', function () {
        var nextValue = String(button.dataset.dealsStock || '').trim();
        state.stock = state.stock === nextValue ? '' : nextValue;
        state.sort = 'latest';
        render(root, state);
      });
    });

    toArray(root.querySelectorAll('[data-deals-sort]')).forEach(function (button) {
      button.addEventListener('click', function () {
        state.sort = String(button.dataset.dealsSort || 'latest').trim() || 'latest';
        state.stock = '';
        render(root, state);
      });
    });

    hydrateGrid(root, state).catch(function (error) {
      console.error('[townwine-deals] failed to hydrate products', error);
      render(root, state);
      var grid = root.querySelector('[data-deals-grid]');
      if (grid instanceof HTMLElement) {
        grid.style.visibility = '';
      }
    });
  }

  function boot(root) {
    toArray((root || document).querySelectorAll(ROOT_SELECTOR)).forEach(function (element) {
      initialize(element);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }
})();
